'use client';

import { useState } from 'react';

import { cn } from '@/lib/utils';

import { envLocale } from '@/constant/env';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import Popover from '@/decodo/components/atoms/Popover';

import { HeaderItem } from './HeaderItem';
import { regions } from '../constants/regions';

import IconGlobe from '~/icons/globe-02.svg';

export function LanguageToggle() {
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (region: (typeof regions)[number]) => {
    if (region.locale === envLocale) return true;
    // TODO: no locale is passed for global at the moment. Assume default.
    if (region.locale === 'en' && !envLocale) return true;
    return false;
  };
  const title = envLocale === 'zh-cn' ? '地区' : 'Region';

  return (
    <Popover
      target={
        <HeaderItem
          icon={
            <IconGlobe className='text-base-dark-white group-data-[hovered=true]/header-list-item:text-gray-dark-500 duration-300' />
          }
          showDropdown={false}
          aria-label={title}
        />
      }
      showArrow={false}
      contentProps={{
        className: 'mt-1 min-w-[152px]',
      }}
      classNames={{
        target: 'h-full',
        childrenWrapper: 'p-4 bg-gray-dark-950 border-gray-dark-800',
      }}
      isOpen={isOpen}
      position='bottom'
      onChange={setIsOpen}
    >
      <p className='text-label-medium text-gray-dark-500 mb-4 font-serif uppercase'>
        {title}
      </p>
      <ul className='flex flex-col gap-y-2'>
        {regions.map((region) => (
          <li key={region.title}>
            <LinkButton
              classNames={{
                root: cn(
                  'px-0 h-6 focus-visible:outline-none focus-visible:underline focus-visible:decoration-inherit',
                  isActive(region) && 'pointer-events-none'
                ),
                inner: isActive(region) ? '' : 'dark',
              }}
              variant='text'
              color={isActive(region) ? 'primary' : 'secondary'}
              href={region.href}
            >
              {region.title}
            </LinkButton>
          </li>
        ))}
      </ul>
    </Popover>
  );
}
